/**
 * Variant drawer picker enhancement.
 *
 * The real option radios live inside <variant-picker> (sr-only); the drawer holds
 * <label for="..."> cards that drive them by id (works even after the theme appends
 * the drawer to <body> on open). On change we: mark the selected card, sync the
 * trigger row's shown value, and auto-close the drawer.
 */
(function () {
  function esc(id) {
    return window.CSS && CSS.escape ? CSS.escape(id) : id.replace(/([^\w-])/g, '\\$1');
  }

  function updateSelectedCard(input) {
    var label = document.querySelector('label[for="' + esc(input.id) + '"]');
    if (!label) return;
    var list = label.closest('.variant-drawer__list');
    if (list) {
      Array.prototype.forEach.call(list.querySelectorAll('.variant-drawer__card'), function (c) {
        c.classList.remove('is-selected');
      });
    }
    label.classList.add('is-selected');
  }

  function syncTrigger(input) {
    var fieldset = input.closest('.variant-input-wrapper');
    if (!fieldset) return;
    var valueEl = fieldset.querySelector('.variant-drawer__trigger-value');
    if (valueEl) valueEl.textContent = input.getAttribute('data-option-value') || input.value;
  }

  function closeDrawer(input) {
    var fieldset = input.closest('.variant-input-wrapper');
    if (!fieldset) return;
    var hit = fieldset.querySelector('.variant-drawer__trigger-hit');
    var drawerId = hit && hit.getAttribute('aria-controls');
    var drawer = drawerId && document.getElementById(drawerId);
    if (!drawer) return;
    var closeBtn = drawer.querySelector('.drawer__close');
    if (closeBtn) requestAnimationFrame(function () { closeBtn.click(); });
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains('variant-drawer__input')) return;
    if (!input.checked) return;
    updateSelectedCard(input);
    syncTrigger(input);
    closeDrawer(input);
  });
})();
